import { StarRatingQuestion } from "../../../types/Question";

// <select 
//   label="Q12"
//   fir="off"
//   uses="starrating.5">
//   <title>New Star Rating Question</title>
//   <comment>Select a star value.</comment>
//   <row label="r1">Example 1</row>
//   <row label="r2">Example 2</row>
//   <row label="r3">Example 3</row>
//   <choice label="ch1">Star 1</choice>
//   <choice label="ch2">Star 2</choice>
//   <choice label="ch3">Star 3</choice>
//   <choice label="ch4">Star 4</choice>
//   <choice label="ch5">Star 5</choice>
// </select>

/**
 * Export question as XML-precursor data type.
*
 * @export
 * @param {StarRatingQuestion} question
 * @return {*}
 */
export default function toXmlType(question: StarRatingQuestion) {
  const xmlJSData = {
    select: {
      _attributes: { label: `Q${question.id}`, fir: "off", uses: "starrating.5" },
      title: question.title,
      alt: question.title,
      choice: [1,2,3,4,5].map(i => {return {
        _attributes: {
          label: `ch${i}`,
        },
        _text: `Star ${i}`,
    }}),
      row: question.has_multiple ? 
        question.options.map(o => { return {
        _attributes: {
          label: `r${o.id}`,
        },
        _text: o.name,
        }}) :
        {
          _attributes: {
            label: `r1`
          },
          _text: ""
        } 
    },
  };
  return xmlJSData;
}
